import { TextField } from '@tryhackme/thm-ui-components';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { useTheme } from 'styled-components';
import { AddWriteupFormInput } from 'src/features/room/components/writeup-modals/writeup-modal.constants';
import { FieldErrors, UseFormRegister } from 'src/common/form';
import { StyledBody, StyledText, StyledTextFieldContainer, StyledTextIcon } from './writeup-modal.styles';
export const AddWriteup = ({
  register,
  errors
}: {
  register: UseFormRegister<AddWriteupFormInput>;
  errors: FieldErrors<AddWriteupFormInput>;
}) => {
  const theme = useTheme();
  const warningIcon = <StyledTextIcon icon={faTriangleExclamation} iconcolour={theme.colors.warning.light} />;
  return <>
      <StyledText data-sentry-element="StyledText" data-sentry-source-file="add-writeup.tsx">
        {warningIcon} Write-ups should have a link to TryHackMe and not include any passwords/cracked hashes/flags
      </StyledText>
      <StyledBody data-sentry-element="StyledBody" data-sentry-source-file="add-writeup.tsx">
        <StyledTextFieldContainer data-sentry-element="StyledTextFieldContainer" data-sentry-source-file="add-writeup.tsx">
          <div>
            <TextField {...register('title')} isError={!!errors.title} errorMessage={((errors.title?.message as unknown) as string)} variant="input" label="Write-up Title" placeholder="Enter Write-up title" id="title" data-sentry-element="TextField" data-sentry-source-file="add-writeup.tsx" />
          </div>
          <div>
            <TextField {...register('link')} isError={!!errors.link} errorMessage={((errors.link?.message as unknown) as string)} variant="input" label="Write-up URL" placeholder="Enter URL" id="link" data-sentry-element="TextField" data-sentry-source-file="add-writeup.tsx" />
          </div>
        </StyledTextFieldContainer>
      </StyledBody>
    </>;
};